import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../services/service.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-postpaid',
  templateUrl: './postpaid.component.html',
  styleUrls: ['./postpaid.component.css']
})
export class PostpaidComponent implements OnInit {
  selectall:boolean=false;
  visible:boolean=false;
  userdata:any;
  count:any=0;
  actions:boolean=false;

  value:any[]=[{
    'planid':'1',
     'planname':'Full Bandwidth',
     'plantype':'primary',
     'paymentType':'No charge',
     'group':'all',
     'Users':'1',
     'Dowm':'No Limit',
     'upload':'No limit',
     'data':'No Limit',
     'time':'Ni Limit',
     'timeframe':'default(24x7)',
     'gen':'As per Invoice Team',
     'emailalerts':'Disable',
     'alertTemplate':'-',
     'sms':'Disable',
     'alerts' :'-',
     'window':'Default',
     'rveune':'-',
     'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  }
  ,
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  { 'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  { 'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  },
  {
    'planid':'1',
    'planname':'Full Bandwidth',
    'plantype':'primary',
    'paymentType':'No charge',
    'group':'all',
    'Users':'1',
    'Dowm':'No Limit',
    'upload':'No limit',
    'data':'No Limit',
    'time':'Ni Limit',
    'timeframe':'default(24x7)',
    'gen':'As per Invoice Team',
    'emailalerts':'Disable',
    'alertTemplate':'-',
    'sms':'Disable',
    'alerts' :'-',
    'window':'Default',
    'rveune':'-',
    'plannames':'Full BandWidth'
  }


];
constructor(private ServerService: ServiceService,private http: HttpClient,private modalService: NgbModal){}

  ngOnInit(): void {
  }

  openLarge(content) {
    this.modalService.open(content, {
      size: 'lg'
    });
   
  }
  
  // openSmall(content) {
  //   this.modalService.open(content, {
  //     size: 'sm'
  //   });
  // }
  
  openSmall(content: any) {
    this.modalService.open(content, { windowClass: 'custom-modal' });
  }
  
  // private getDismissReason(reason: any): string {
  //   if (reason === ModalDismissReasons.ESC) {
  //     return 'by pressing ESC';
  //   } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
  //     return 'by clicking on a backdrop';
  //   } else {
  //     return `with: ${reason}`;
  //   }
  // }
  
  Delete()
  {
    Swal.fire({
      title: 'Are you sure to Delete?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    });
  }
  
  display()
  {
   this.visible=!this.visible;
  }
  child()
  {
    for(let i=0;i<this.value.length;i++)
    {
      if(this.value[i])
      {
        this.value[i].selected=this.selectall;
      }
    }
  }
  update(item:any)
  {
    if(item.selected)
    {
      alert("You are selected One item");
      this.count++;
      console.log(this.count);
      if(this.count==this.value.length && this.count>=this.value.length )
        {
          this.selectall=true;
        }
        else if(this.count==this.value.length)
        {
          this.count=0;
        }
    }
    else
    {
      this.selectall=false;
      const index = item.selected.indexOf(item);
       item.selected.splice(index, 1);
       alert('deleted Succesfully');
    }  
  }


  userclick()
  {
   this.actions=!this.actions;
 
  }

  openLargeview(content) {
    this.modalService.open(content, {
      size: 'lg'
    });
   
  }
 
}
